import React from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';
import SelectDate from '../../component/SelectDate';
import MyButton from '../../component/Button';

import PageBar from '../../component/PageBar';
// import {listNotice} from '../../lib/Notice';
import moment from 'moment';

import './report.css';

class List extends React.Component {
    constructor(props) {
        super(props);

        const query = queryString.parse(window.location.search);
        const page = query.page ? query.page : 1;

        this.state = {
            items: [],
            search: {
                searchKeyword: '',
                pageNumber: 1,
                size: 20,
            },
            totalPages: 20,
        };
    }

    reloadList = page => {
        const params = this.state.search;
        params.pageNumber = page;
        // sessionStorage.setItem('notice_list', JSON.stringify(params));
        // sessionStorage.setItem('notice_list_important', JSON.stringify(this.state.important));

        this.setState({
            search: params,
        });

        // listNotice(this, params, this.resultList.bind(this));
    };

    /**
     * 등록
     * @param {*} e
     */
    clickAdd = e => {
        // this.props.history.push('/a/board/edit');
        // window.history.pushState({ type: 11 }, undefined, '/a/board/edit');
        window.location = '/a/board/edit';
    };

    /**
     * 셀 클릭
     */
    clickRow = id => {
        // this.props.history.push('/notice/info/' + id);
        window.location = '/a/board/edit/' + id;
    };

    render() {
        return (
            <div>
                <Row
                    onClick={e => {
                        // if (this.state.showStatus) {
                        //     this.setState({ showStatus: false });
                        // }
                        // if (this.state.showImportant) {
                        //     this.setState({ showImportant: false });
                        // }
                    }}
                >
                    <Col>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">견적서</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <table style={{ width: 1000 }}>
                                    <tr>
                                        <td></td>
                                        <td>한국분동</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                </table>
                                <div className="gab40"></div>
                                <table style={{ width: 1000 }}>
                                    <tr>
                                        <td></td>
                                        <td>한국분동</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                </table>
                                <div className="gab40"></div>
                                <table style={{ width: 1000 }}>
                                    <tr>
                                        <td></td>
                                        <td>한국분동</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                </table>
                            </Card.Body>
                        </Card>

                        <div className="voting_fixed_bottom">
                            <div className="board_top_box">
                                <div className="lb"></div>

                                <div className="rb">
                                    <MyButton title={'전체 출력'} variant="primary" onClick={this.clickPrint} />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
